import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import { useFormikContext } from 'formik'
import discountsQuery from 'Shared/Discount/DiscountsQuery'
import { formatDate } from 'Utils/Dates'
import { paymentSetData } from 'Checkout/Redux/Actions/Payment'
import { clearShowCouponMessage } from 'Checkout/Redux/Slices/CartSlice'
import Coupon from 'Shared/Coupon/Coupon'
import Discount from 'Shared/Discount/Discount'

const DiscountWrap = () => {
  const { values: { couponCode, discount } } = useFormikContext()
  const dispatch = useDispatch()
  const [getDiscounts, { data, loading, error }] = useLazyQueryNoCache(discountsQuery)
  const { slug: campgroundSlug, canUseCouponCodes, couponsActiveCount } = useSelector(state => state.campground)
  const discountsArray = data?.campground?.discountClubsForRates || []
  const reservations = useSelector(state => state.cart.reservations)
  const { pricing, showCouponMessage } = useSelector(state => state.cart)
  const { couponApplied } = pricing.data
  const { from, to } = reservations[0]
  const rateIds = reservations.map(({ rateId }) => rateId)

  useEffect(() => {
    dispatch(paymentSetData({ discount, isNonRefundable: discount.name === 'Non-Refundable' }))
  }, [discount.id])

  useEffect(() => {
    dispatch(clearShowCouponMessage())
    dispatch(paymentSetData({ couponCode }))
  }, [couponCode])

  useEffect(() => {
    if (campgroundSlug && rateIds && from && to && !loading) {
      const discountQueryArgs = { variables: { from: formatDate(from), isPos: false, rateIds,
                                               slug: campgroundSlug, to: formatDate(to) } }

      getDiscounts(discountQueryArgs)
    }
  }, [campgroundSlug, from, to])

  return (
    <div className="row border-bottom mb-4 pb-4 ">
      <div>
        <h4>Discounts</h4>

        <p className="text-muted">You may only use a discount or a coupon code.</p>
      </div>

      {discountsArray.length > 0 && (
        <div className={couponsActiveCount ? 'col' : 'col-12'}>
          <Discount discountsArray={discountsArray} disabled={!!couponCode} error={error} isFloating
                    layoutColumn={{ first: 12, second: 12 }} loading={loading} note="Discount Club"
                    numberRequired={discount.isNumberRequired} title="" />
        </div>
      )}

      {couponsActiveCount > 0 && canUseCouponCodes && (
        <div className={discountsArray.length ? 'col' : 'col-12'}>
          <Coupon couponCode={couponCode} disabled={!!discount.id} couponApplied={couponApplied}
                  showCouponMessage={showCouponMessage} />
        </div>
      )}
    </div>
  )
}

export default DiscountWrap
